import { render, staticRenderFns } from "./ClientVisit.vue?vue&type=template&id=177eddb9&scoped=true"
import script from "./ClientVisit.vue?vue&type=script&lang=js"
export * from "./ClientVisit.vue?vue&type=script&lang=js"
import style0 from "./ClientVisit.vue?vue&type=style&index=0&id=177eddb9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177eddb9",
  null
  
)

export default component.exports